import type { CustomerRepository } from '../domain/CustomerRepository';

export const getCustomer = (repository: CustomerRepository) => {
  return repository.get();
};
